import { useMemo } from 'react'
import { Notification, NotificationContext, useNotificationContext, type NotificationProps } from 'react-admin'
import { explainNotification } from '../../lib/formErrorsOnScreen'

/**
 * A Notification do react-admin, com o "formulário inválido" explicado campo a campo
 * (`explainNotification`). Fica no `<Admin notification>`: vale para todo formulário do painel.
 *
 * A Notification pega a mensagem com `takeNotification()`; o embrulho só troca essa função.
 * Ela é chamada depois do render que pintou os campos de vermelho, então a tela já mostra os erros.
 */
export const FormErrorNotification = (props: NotificationProps) => {
  const context = useNotificationContext()
  const value = useMemo(
    () => ({
      ...context,
      takeNotification: () => {
        const notification = context.takeNotification()
        return notification ? explainNotification(notification) : notification
      },
    }),
    [context],
  )
  return (
    <NotificationContext.Provider value={value}>
      <Notification {...props} />
    </NotificationContext.Provider>
  )
}

export default FormErrorNotification
